<div class="flex flex-col">
    <!-- Title and chevron -->
    <div class="flex items-center gap-2 cursor-pointer clickable" (click)="toggleExpand()">
        <ng-content select="[title]"></ng-content>
        <p class="default-title">Expanding content</p>
        <mat-icon svgIcon="chevron-down" iconPositionEnd [ngClass]="{'rotated': expanded}"
            [class]="iconClass"></mat-icon>
    </div>

    <!-- Expansion content -->
    <div class="content-container" [@expandCollapse]="expanded ? 'expanded' : 'collapsed'" *ngIf="initialized">
        <ng-content></ng-content>
    </div>
</div>